export default "__VITE_ASSET__CKWwaxm8__"